import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import MainAuthenticatedRoutes from './MainAuthenticatedRoutes';
import LoginRoutes from './LoginRoutes';
import MinimalLayout from './MinimalRoutes';

export default function ThemeRoutes() {
    return useRoutes([MainAuthenticatedRoutes, MainRoutes, LoginRoutes, MinimalLayout]);
}
